import { InputField } from 'components/form/field/InputField';
import { Modal } from 'components/Modal/Modal';
import { useCallback, useState } from 'react';
import i18n from 'i18n';
import { DefaultECSegmentManager, ECSegmentManager } from 'core/ecSegment/ECSegmentManager';
import { useCallAPI } from 'hooks/useCallAPI';
import { LoadingIndicator } from 'components/LoadingIndicator';
import styles from './ecSegmentList.module.scss';

const ecSegmentManager: ECSegmentManager = new DefaultECSegmentManager();
export const IntersectECSegmentModal: React.FC<{
  advertiserId: number;
  selectedSegmentIds: [string, string];
  onClose: (needRefreshList: boolean) => void;
}> = ({
  advertiserId,
  selectedSegmentIds,
  onClose
}) => {

  const {
    loading,
    callAPIs
  } = useCallAPI();

  const [segmentName, setSegmentName] = useState<string>('');
  const [id1, id2] = selectedSegmentIds;
  const onNameChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSegmentName(e.target.value);
  }, []);

  const intersectECSegments = useCallback(() => {
    callAPIs([() => ecSegmentManager.intersectECSegments(advertiserId, segmentName, id1, id2)], () => {
      onClose(true);
    });
  }, [advertiserId, segmentName, id1, id2, onClose, callAPIs]);

  const onCloseModal = useCallback(() => {
    onClose(false);
  }, [onClose]);

  return (
    <Modal
      title={i18n.t<string>('ecSegmentList.titles.intersectSegmentModal')}
      primaryButton={{
        title: i18n.t<string>('common.buttons.save'),
        callback: intersectECSegments
      }}
      secondaryButton={{
        title: i18n.t<string>('common.buttons.close'),
        callback: onCloseModal
      }}
      dismiss={onCloseModal}
      className={styles.intersectECSegmentModal}
    >
      <div>
        {loading && <LoadingIndicator />}
        <InputField
          name='intersectSegmentName'
          label={i18n.t<string>('ecSegmentList.labels.segmentName')}
          placeholder={i18n.t<string>('ecSegmentList.placeholders.segmentName')}
          value={segmentName}
          onChange={onNameChange}
        />
      </div>
    </Modal>
  );
};
